/* src/app/cart/cart-preview/cart-preview.component.scss */
.cart-preview-container {
  background-color: #f6f6f6;
  max-width: 770px;
}
.header-preview {
  padding: 20px 30px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
}
h2 {
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.close {
  margin: 0;
  min-height: 0;
}
.close::part(native) {
  padding: 0;
}
.close ion-icon {
  color: black;
  font-size: 25px;
}
.card {
  background-color: white;
  border-radius: 20px;
}
.free-shipping-progress-container {
  height: auto;
  padding: 20px;
  font-size: 18px;
  font-weight: 500;
  color: #949494;
  border: 1px solid black;
}
.free-shipping-progress-container strong {
  color: black;
}
.free-shipping-progress-container ion-progress-bar {
  height: 10px;
  border-radius: 20px;
  --background: #f6f6f6 !important;
  box-shadow: inset 0px 3px 4px 0px rgba(0, 0, 0, 0.2);
}
.free-shipping-progress-container .green-progress-bar {
  --progress-background: #0acf83;
}
h1 {
  font-size: 32px;
  font-weight: 600;
}
.shadowEmptyCart {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
}
.emptyCart {
  padding: 30px 10px 0 10px;
}
.img-carrito-vacio {
  height: auto;
  width: 50px;
}
.cart-items-header ion-icon {
  height: 32px;
  width: 32px;
  color: #259dff;
  flex-shrink: 0;
}
.resumen-pedido-container {
  padding: 30px;
  overflow-y: auto;
}
.seguir-comprando-button {
  --background: black !important;
  width: 86%;
}
.seguir-comprando-button-in-page {
  --background: black !important;
  width: 100%;
}
.continuar-envio-container {
  background-color: white;
  height: 134px;
  padding: 20px;
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.1490196078);
}
.continuar-envio-container > div {
  width: 86%;
  gap: 10px;
}
.continuar-envio-container ion-button[fill=clear] {
  text-decoration: underline;
  min-height: 0;
  --border-radius: 0;
}
.continuar-envio-container ion-button[fill=clear]::part(native) {
  padding: 0;
  width: auto;
  height: auto;
}
.productos {
  margin-top: 29px;
}
.productos .amount {
  font-weight: bolder;
}
.margin-section {
  margin-top: 16px;
}
.product-container {
  border-radius: 20px;
  border: 1px solid black;
  padding: 20px;
  background-color: #f6f6f6;
}
.product-container ion-text {
  color: #949494;
  font-weight: 600;
  font-size: 20px;
}
.product-container ion-checkbox {
  --size: 22px;
  --border-radius: 4px;
}
.cart-items-section {
  border-radius: 20px;
  border: 1px solid #949494;
  background-color: white;
}
.items-subheader ion-icon {
  height: 32px;
  width: 32px;
  color: #ff007f;
  flex-shrink: 0;
}
.items-subheader h3 {
  font-family: "Barlow Semi Condensed";
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.items-subheader ion-button {
  --border-radius: 15px;
  --color: white;
  min-height: 0;
  margin: 0;
}
.items-subheader ion-button::part(native) {
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.items-subheader ion-button ion-icon {
  width: 22px;
  height: 22px;
  color: white;
  margin-right: 10px;
}
.order-costs-container {
  padding: 0px 20px 0px 20px;
}
.ticket-container {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.2));
}
.ticket-container img {
  pointer-events: none;
}
.ticket-div {
  background-color: white;
  padding: 20px 30px 20px 30px;
}
@media (max-width: 1024px) {
  .ticket-div {
    padding: 20px;
  }
  .discount,
  coupon-code-span {
    font-size: 16px;
  }
}
@media (max-width: 500px) {
  h2 {
    font-size: 20px;
  }
  .close ion-icon {
    font-size: 22px;
  }
}
.save-draft-order {
  border-radius: 15px;
  padding: 14px 18px;
  background-color: #f6f6f6;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.save-draft-order ion-icon {
  font-size: 24px;
}
.save-draft-order:hover {
  opacity: 0.8;
}
.discount {
  font-size: 18px;
  font-weight: 500;
}
.coupon-code-span {
  font-size: 18px;
  font-weight: 500;
}
.remove-coupon {
  border: 1px solid #949494;
  border-radius: 20px;
  padding: 8px 8px 8px 16px;
}
.remove-coupon ion-text {
  color: #0c8ce9;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}
.remove-coupon ion-button {
  --background: #f6f6f6;
  --background-hover: #f9f9f9;
  --background-activated: #eeeeee;
  --border-radius: 15px;
  font-weight: 500;
  font-size: 18px;
  color: #eb445a;
  margin: 0;
}
.remove-coupon ion-button ion-icon {
  color: #eb445a;
}
::ng-deep .coupon-warning {
  --border-radius: 30px;
}
.recommendedProductsDiv {
  padding: 10px 0 10px 0;
  border: 1px solid #cbcbcb;
  overflow: hidden;
  border-radius: 15px;
}
.recommendedProductsDiv span {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 20px;
}
.recommendedProductsDiv .closeButton {
  min-height: unset;
  margin: 0;
}
.recommendedProductsDiv .closeButton::part(native) {
  padding: 0 !important;
}
.coupon-description-span {
  color: #949494;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #cbcbcb;
}
/*# sourceMappingURL=cart-preview.component-J4AXWLN4.css.map */
